'use strict';

/*global services*/
/*global replaceAttrKey*/
/*global blockElement*/
/*global unBlockElement*/
/*global WinsHandsontable*/
/*global itemTableData*/
/*global itemTableColumns*/
/*global itemTableErrors*/
function RegistrationItemsDefinition($container) {
    this.$container = $container;

    this.tableColumns = null;
    this.tableData = null;
    this.tableErrors = null;
    this.$itemTable = null;
    this.itemTable = null;

    this.init();
}

RegistrationItemsDefinition.prototype = $.extend({}, {
    construtor: 'RegistrationItemsDefinition',

    //**************************************************************************

    registerCallbacks: function registerCallbacks() {
        var _this = this;

        _this.$container.on('click', '.item-definition__table-toggle', function () {
            _this.toggleTable();

            return false;
        });

        _this.$container.on('submit', function () {
            _this.submit();
        });

        return _this;
    },

    //**************************************************************************

    submit: function submit() {
        var _this = this;

        if (_this.$itemTable.length) {
            var data = _this.itemTable.getData();
            _this.$container.find('[name$="data"]').val(JSON.stringify(data));
        }

        return _this;
    },

    toggleTable: function toggleTable() {
        var _this = this;

        _this.$container.find('.item-definition__table-toggle').hide();
        var $wrapper = _this.$container.find('.item-definition__table');

        blockElement($wrapper);
        $wrapper.slideDown(function () {
            var data = [];
            var row = {};

            for (var column in _this.tableColumns) {
                if (column in _this.tableColumns) {
                    var name = _this.tableColumns[column].data;

                    var tagName = _this.$container.find('[name$="' + name + '_value"]').prop('tagName');
                    if (tagName.toLowerCase() === 'select') {
                        row[name] = _this.$container.find('[name$="' + name + '_value"] option:selected').text();
                    } else {
                        row[name] = _this.$container.find('[name$="' + name + '_value"]').val();
                    }
                }
            }

            data.push(row);
            _this.itemTable.setData(data);
            unBlockElement($wrapper);
        });

        return _this;
    },

    initTable: function initTable() {
        var _this = this;

        _this.itemTable = new WinsHandsontable(_this.$itemTable, $.extend({}, {
            data: _this.tableData,
            columns: _this.tableColumns
        }));

        _this.itemTable.setErrors(_this.tableErrors);

        return _this;
    },

    //**************************************************************************    

    init: function init() {
        var _this = this;

        _this.registerCallbacks();
        _this.$itemTable = _this.$container.find('.item-definition-table');
        if (_this.$itemTable.length) {
            _this.tableData = itemTableData;
            _this.tableColumns = itemTableColumns;
            _this.tableErrors = itemTableErrors;    
            _this.initTable();
        }

        return _this;
    }
});
